import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import AiVisibility from "@/pages/admin/AiVisibility";
export const Route = createFileRoute("/admin/ai-visibility")({ component: () => <RouteGuard access={{ kind: "admin" }}><AiVisibility /></RouteGuard> });
